import * as React from 'react';
import { Accordion as CianAccordion, IAccordionProps } from '@cian/ui-kit';

export const UiKitAccordion: React.FC<{ items: string }> = ({ items }) => {
  const preparedItems = React.useMemo(() => {
    const parsedItems = JSON.parse(items) as IAccordionProps['items'];

    return parsedItems.map(item => ({
      ...item,
      content: item.content,
    }));
  }, [items]);

  return <CianAccordion items={preparedItems} />;
};
